import React, {Fragment} from "react"

const handleSubmit = (e) => {
    e.preventDefault();
}

const CommentForm = () => {
    return (
        <Fragment>
            <form className="contact-form" action="#" onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-lg-6">
                        <div className="input-box mb-40">
                            <label>Nombre</label>
                            <input type="email" placeholder="Ingresa tu Nombre"/>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="input-box mail-input mb-40">
                            <label>Correo</label>
                            <input type="text" placeholder="Correo Electrónico"/>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="input-box text-input mb-60">
                            <label>Comentarios</label>
                            <textarea
                                name="message"
                                cols={30}
                                rows={10}
                                placeholder="Escribe tus Comentarios"
                                defaultValue={""}/>
                        </div>
                    </div>
                    <div className="col-12">
                        <button className="theme_btn">Publicar Comentario</button>
                    </div>
                </div>
            </form>
        </Fragment>
    )
}

export default CommentForm